import { Divider, styled, Tab } from '@mui/material';
import React from 'react';
/**
 * Renders a divider tab between global tabs, used to indicate possible drop positions during drag-and-drop reordering.
 *
 * @param {object} root0 - Props object.
 * @param {number} root0.index - Index position of the divider in the tab list.
 * @param {boolean} root0.movePlaceholder - Whether the divider is currently used as a placeholder during a tab move operation.
 * @returns {JSX.Element} A styled tab used as a visual divider in the tab list.
 */
export const GlobalTabDivider = ({ index, movePlaceholder }) => {
    const hidden = index === 0 && !movePlaceholder;
    return (React.createElement(StyledTab, { sx: {
            px: hidden ? 0 : '4px',
            minWidth: 'initial',
            visibility: hidden ? 'hidden' : 'visible',
            overflow: movePlaceholder ? 'visible' : 'hidden',
        }, icon: React.createElement(Divider, { orientation: 'vertical', sx: { height: '24px', alignSelf: 'center' } }), "data-index": index.toString(), "aria-hidden": 'true', disabled: true }));
};
const StyledTab = styled(Tab)(() => ({
    maxWidth: '300px',
    maxHeight: '30px',
    padding: '3px 8px',
}));
